import { cabinetApi as api } from "../api";
export const addTagTypes = ["ProfileCategory", "api"] as const;
const injectedRtkApi = api
  .enhanceEndpoints({
    addTagTypes,
  })
  .injectEndpoints({
    endpoints: (build) => ({
      appProfilesCategoriesList: build.query<
        AppProfilesCategoriesListApiResponse,
        AppProfilesCategoriesListApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-profiles/categories/`,
          params: {
            leader: queryArg,
          },
        }),
        providesTags: ["ProfileCategory"],
      }),
      appProfilesCategoriesCreate: build.mutation<
        AppProfilesCategoriesCreateApiResponse,
        AppProfilesCategoriesCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-profiles/categories/`,
          method: "POST",
          body: queryArg,
        }),
        invalidatesTags: ["ProfileCategory"],
      }),
      appProfilesCategoriesRetrieve: build.query<
        AppProfilesCategoriesRetrieveApiResponse,
        AppProfilesCategoriesRetrieveApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-profiles/categories/${queryArg}/`,
        }),
        providesTags: ["ProfileCategory"],
      }),
      appProfilesCategoriesUpdate: build.mutation<
        AppProfilesCategoriesUpdateApiResponse,
        AppProfilesCategoriesUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-profiles/categories/${queryArg.id}/`,
          method: "PUT",
          body: queryArg.profileCategoryRequest,
        }),
        invalidatesTags: ["ProfileCategory"],
      }),
      appProfilesCategoriesPartialUpdate: build.mutation<
        AppProfilesCategoriesPartialUpdateApiResponse,
        AppProfilesCategoriesPartialUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-profiles/categories/${queryArg.id}/`,
          method: "PATCH",
          body: queryArg.patchedProfileCategory,
        }),
        invalidatesTags: ["ProfileCategory"],
      }),
      appProfilesCategoriesDestroy: build.mutation<
        AppProfilesCategoriesDestroyApiResponse,
        AppProfilesCategoriesDestroyApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-profiles/categories/${queryArg}/`,
          method: "DELETE",
        }),
        invalidatesTags: ["ProfileCategory"],
      }),
      appProfilesNotesList: build.query<
        AppProfilesNotesListApiResponse,
        AppProfilesNotesListApiArg
      >({
        query: () => ({ url: `/api/v1_15/app-profiles/notes/` }),
        providesTags: ["api"],
      }),
      appProfilesNotesCreate: build.mutation<
        AppProfilesNotesCreateApiResponse,
        AppProfilesNotesCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-profiles/notes/`,
          method: "POST",
          body: queryArg,
        }),
        invalidatesTags: ["api"],
      }),
      appProfilesNotesRetrieve: build.query<
        AppProfilesNotesRetrieveApiResponse,
        AppProfilesNotesRetrieveApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-profiles/notes/${queryArg}/`,
        }),
        providesTags: ["api"],
      }),
      appProfilesNotesUpdate: build.mutation<
        AppProfilesNotesUpdateApiResponse,
        AppProfilesNotesUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-profiles/notes/${queryArg.id}/`,
          method: "PUT",
          body: queryArg.profileCategoryNoteRequest,
        }),
        invalidatesTags: ["api"],
      }),
      appProfilesNotesPartialUpdate: build.mutation<
        AppProfilesNotesPartialUpdateApiResponse,
        AppProfilesNotesPartialUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-profiles/notes/${queryArg.id}/`,
          method: "PATCH",
          body: queryArg.patchedProfileCategoryNote,
        }),
        invalidatesTags: ["api"],
      }),
      appProfilesNotesDestroy: build.mutation<
        AppProfilesNotesDestroyApiResponse,
        AppProfilesNotesDestroyApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-profiles/notes/${queryArg}/`,
          method: "DELETE",
        }),
        invalidatesTags: ["api"],
      }),
    }),
    overrideExisting: false,
  });
export { injectedRtkApi as profilesGenerated };
export type AppProfilesCategoriesListApiResponse =
  /** status 200  */ ProfileCategoryListDict;
export type AppProfilesCategoriesListApiArg = number;
export type AppProfilesCategoriesCreateApiResponse =
  /** status 201  */ ProfileCategory;
export type AppProfilesCategoriesCreateApiArg = ProfileCategoryRequest;
export type AppProfilesCategoriesRetrieveApiResponse =
  /** status 200  */ ProfileCategory;
export type AppProfilesCategoriesRetrieveApiArg =
  /** A unique integer value identifying this profile category. */ number;
export type AppProfilesCategoriesUpdateApiResponse =
  /** status 200  */ ProfileCategory;
export type AppProfilesCategoriesUpdateApiArg = {
  /** A unique integer value identifying this profile category. */
  id: number;
  profileCategoryRequest: ProfileCategoryRequest;
};
export type AppProfilesCategoriesPartialUpdateApiResponse =
  /** status 200  */ ProfileCategory;
export type AppProfilesCategoriesPartialUpdateApiArg = {
  /** A unique integer value identifying this profile category. */
  id: number;
  patchedProfileCategory: PatchedProfileCategory;
};
export type AppProfilesCategoriesDestroyApiResponse = unknown;
export type AppProfilesCategoriesDestroyApiArg =
  /** A unique integer value identifying this profile category. */ number;
export type AppProfilesNotesListApiResponse =
  /** status 200  */ ProfileCategoryNote[];
export type AppProfilesNotesListApiArg = void;
export type AppProfilesNotesCreateApiResponse =
  /** status 201  */ ProfileCategoryNote;
export type AppProfilesNotesCreateApiArg = ProfileCategoryNoteRequest;
export type AppProfilesNotesRetrieveApiResponse =
  /** status 200  */ ProfileCategoryNote;
export type AppProfilesNotesRetrieveApiArg =
  /** A unique integer value identifying this profile category note. */ number;
export type AppProfilesNotesUpdateApiResponse =
  /** status 200  */ ProfileCategoryNote;
export type AppProfilesNotesUpdateApiArg = {
  /** A unique integer value identifying this profile category note. */
  id: number;
  profileCategoryNoteRequest: ProfileCategoryNoteRequest;
};
export type AppProfilesNotesPartialUpdateApiResponse =
  /** status 200  */ ProfileCategoryNote;
export type AppProfilesNotesPartialUpdateApiArg = {
  /** A unique integer value identifying this profile category note. */
  id: number;
  patchedProfileCategoryNote: PatchedProfileCategoryNote;
};
export type AppProfilesNotesDestroyApiResponse = unknown;
export type AppProfilesNotesDestroyApiArg =
  /** A unique integer value identifying this profile category note. */ number;
export type ProfileCategory = {
  id: number;
  leader: number;
  title?: string | null;
  icon?: string;
  icon_url?: string | null;
  order?: number;
  notes: number[];
};
export type ProfileCategoryListDict = {
  [key: string]: ProfileCategory;
};
export type ProfileCategoryRequest = {
  leader: number;
  title?: string | null;
  icon?: string;
  icon_url?: string | null;
  order?: number;
};
export type PatchedProfileCategory = {
  leader?: number;
  title?: string | null;
  icon?: string;
  icon_url?: string | null;
  order?: number;
};
export type ProfileCategoryNote = {
  id: number;
  profile_category: number;
  title?: string | null;
  subtitle?: string | null;
  image_url?: string | null;
  header_fields?: any;
  notes?: string | null;
  custom?: any;
};
export type ProfileCategoryNoteRequest = {
  profile_category: number;
  title?: string | null;
  subtitle?: string | null;
  image_url?: string | null;
  header_fields?: any;
  notes?: string | null;
  custom?: any;
};
export type PatchedProfileCategoryNote = {
  profile_category?: number;
  title?: string | null;
  subtitle?: string | null;
  image_url?: string | null;
  header_fields?: any;
  notes?: string | null;
  custom?: any;
};
export const {
  useAppProfilesCategoriesListQuery,
  useAppProfilesCategoriesCreateMutation,
  useAppProfilesCategoriesRetrieveQuery,
  useAppProfilesCategoriesUpdateMutation,
  useAppProfilesCategoriesPartialUpdateMutation,
  useAppProfilesCategoriesDestroyMutation,
  useAppProfilesNotesListQuery,
  useAppProfilesNotesCreateMutation,
  useAppProfilesNotesRetrieveQuery,
  useAppProfilesNotesUpdateMutation,
  useAppProfilesNotesPartialUpdateMutation,
  useAppProfilesNotesDestroyMutation,
} = injectedRtkApi;
